import cn from 'classnames';
import type { ComponentProps, FC } from 'react';
import React from 'react';

import styles from './styles.module.scss';

interface IContentItemProps extends ComponentProps<'div'> {
    title: string;
}

export const ContentItem: FC<IContentItemProps> = ({ title, children }) => (
    <div className={cn(styles.root)}>
        <div className={cn('h-mb-4 h-color-D60')}>{title}</div>
        <div className={styles.childrenBlock}>{children}</div>
    </div>
);
